<template>
  <div id="app">
    <transition name="show-from-left">
        <popover name="helpsubsets" :width="240">
            <Help :titleChart="titleChart">
            <div slot="content">
              <p> {{ $t("243") }}</p>
            </div>
          </Help>
        </popover>
    </transition>

    <div class="title-charts title-bt-help">{{ $t("244") }} 
      <button class="bt-help" v-popover:helpsubsets.right><i class="icon-help ti-help-alt"></i></button>
    </div>

    <highcharts :options="chartOptions" ref='chart'></highcharts>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Vue from 'vue'
import axios from 'axios';
import mixin from '../../../../utils/mixin'

import Popover  from 'vue-js-popover'
Vue.use(Popover)
import Help from 'src/components/Dashboard/Views/components/Help'

export default {
  name: 'charts',
  components: {
    Help
  },
  data () {
    return {
      titleChart: this.$t("244"),
      tableData: [],
      chartOptions: {
        //colors: ['#8b3d88', '#90ed7d', '#e4d354', '#f45b5b', '#6b91c9', '#3e9b80', '#3257a8'],
        chart: {
          type: 'pie',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063',
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0,
          }
        },
        title: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase',
            fontSize: '16px',
            fontWeight: 'bold'
          }
        },
        subtitle: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase'
          }
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        xAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        yAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          tickWidth: 1,
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        tooltip: {
          headerFormat: '',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b>',
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          style: {
            color: '#F0F0F0'
          }
        },
        plotOptions: {
          pie: {
            borderWidth: 0, // < set this option
            size: '80%',
            dataLabels: {
              distance: 15
            },
            depth: 55
          },
          series: {
              innerSize: '50%',
            dataLabels: {
              enabled: true,
              format: '<span style="color:#fff ">{point.name}:<br></span><span style="color:#fff "> {point.y}</span>',
              color: '#F0F0F3',
              style: {
                fontSize: '12px',
              }
            },
            marker: {
              lineColor: '#333'
            },
            events:{
              click: this.loadGrid
            },
          },
          boxplot: {
            fillColor: '#505053'
          },
          candlestick: {
            lineColor: 'white'
          },
          errorbar: {
            color: 'white'
          }
        },
        legend: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          itemStyle: {
              color: '#E0E0E3'
          },
          itemHoverStyle: {
              color: '#FFF'
          },
          itemHiddenStyle: {
              color: '#606063'
          },
          title: {
            style: {
              color: '#C0C0C0',
              fontSize: '12px'

            }
          }
        },
        credits: {
          style: {
            color: '#666'
          }
        },
        labels: {
          style: {
            color: '#707073'
          }
        },
        drilldown: {
          activeAxisLabelStyle: {
            color: '#F0F0F3'
          },
          activeDataLabelStyle: {
            color: '#F0F0F3'
          }
        },
        navigation: {
          buttonOptions: {
            symbolStroke: '#DDDDDD',
            theme: {
              fill: '#505053'
            }
          }
        },
        // scroll charts
        rangeSelector: {
          buttonTheme: {
            fill: '#505053',
            stroke: '#000000',
            style: {
              color: '#CCC'
            },
            states: {
              hover: {
                fill: '#707073',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              },
              select: {
                fill: '#000003',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              }
            }
          },
          inputBoxBorderColor: '#505053',
          inputStyle: {
            backgroundColor: '#333',
            color: 'silver'
          },
          labelStyle: {
            color: 'silver'
          }
        },
        navigator: {
          handles: {
            backgroundColor: '#666',
            borderColor: '#AAA'
          },
          outlineColor: '#CCC',
          maskFill: 'rgba(255,255,255,0.1)',
          series: {
            color: '#7798BF',
            lineColor: '#A6C7ED'
          },
          xAxis: {
            gridLineColor: '#505053'
          }
        },
        scrollbar: {
          barBackgroundColor: '#808083',
          barBorderColor: '#808083',
          buttonArrowColor: '#CCC',
          buttonBackgroundColor: '#606063',
          buttonBorderColor: '#606063',
          rifleColor: '#FFF',
          trackBackgroundColor: '#404043',
          trackBorderColor: '#404043'
        },
        series: [
        {
          name: "SAMPLES",
          colorByPoint: true,
          data: []
        }
      ],
      drilldown: {
        series: []
      },
      exporting: { enabled: false },
      credits: {
        enabled: false
      },
      loading: {
          labelStyle: {
              color: 'black',
              textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff',
          },
          style: {
              backgroundColor: 'none',
              opacity: 1,
              marginTop: '20px'
          }
      },

      },//fim chartOptions
    }
  },
  mixins: [mixin],
  methods: {
    ...mapMutations(['changeGridOnline']),

    loadGrid(event){
      let status = event.point.drilldown;
      let point_name = event.point.name
      let NAME_CHART = this.$t("368") + ' - ' + point_name.toUpperCase()
      const ENDPOINT = `v1/mysemeq-ambev/get-equip-status-grid?corp=${this.filtersOn.corp}&region=${this.filtersOn.region}&planta=${this.filtersOn.planta}&status=${status}&skipped=&area_f=${this.filtersOn.area_f}&sector_f=${this.filtersOn.sector_f}&machine=${this.filtersOn.machine}&subset=${this.filtersOn.subset}`

      let gridOnline = {
        title: event.point.name,
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
              "area": [this.$t("311")],
              "setor": [this.$t("312")],
              "conj": [this.$t("316"), 'conjunto'],
              "conj_tag": [this.$t("317")],
              "equip": [this.$t("313")],
              "equip_tag": [this.$t("314")],
              "data": [this.$t("334")],
              "status": ['Status'],
              "rdps": [this.$t("161")],
              "approved_datetime": [this.$t("320")]
        },
        show: true,
        titleHelp: 'Grid - ' + this.$t("368"),
        txtHelp: this.$t("369") 
      }

      if (!this.filtersOn.planta) {
        gridOnline.columns = {"rows": [''], 'planta': [this.$t("310"), 'planta_f'], ...gridOnline.columns}
      }
      else{
        gridOnline.columns = {"rows": [''],  ...gridOnline.columns}
      }

      if (this.filtersOn.planta) {
        gridOnline.title += ' - ' + this.filtersOn.planta_name
        delete gridOnline.columns['planta']
      }

      this.changeGridOnline(gridOnline);

    },
    getData(){
      const API = process.env.ROOT_API;
      //const ENDPOINT = 'v1/get-equip-status'
      const ENDPOINT = 'v1/mysemeq-ambev/get-equip-status'
      let self = this;

      this.$refs.chart.chart.showLoading();

      axios({method: 'GET', url: API + ENDPOINT, params: this.filtersOn, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(resp => {
        self.tableData = resp.data.result;
        self.$refs.chart.chart.hideLoading();
      })
      .catch(err => {
        self.$refs.chart.chart.showLoading('Error');

        // from mixin
        self.ApiErrorHandler(self, error.response.data.status_code);
      })

    },
    setChartData () {
        var self = this
        var res = self.tableData
        var values = []

        for (var key in res) {
          if(res[key].status == 1){
            var color = '#90ed7d'
            var name = this.$t("306")
          }
          if(res[key].status == 2){
            var color = '#e4d354'
            var name = this.$t("307")
          }
          if(res[key].status == 3){
            var color = '#f45b5b'
            var name = this.$t("308")
          }
          if(res[key].status == 4){
            var color = '#6b91c9'
            var name = this.$t("309")
          }

          values.push({'name': name, 'y': res[key].total, 'drilldown': res[key].status, 'color': color})
      }
      self.chartOptions.series[0].data = values


    }
  },
  computed: {
    ...mapGetters(['filtersOn']),
  },
  watch: {
    filtersOn: function(newValue){
      this.getData();
    },
    tableData: function(){
      this.setChartData();
    }
  }
}
</script>
<style scoped>

tspan {
    /*fill: #fff;*/
    stroke: none!important;
    stroke-width: 1px;
    stroke-linejoin: round;
    /*color: #fff;*/
/*  font-weight: normal;
    font-size: 12px;*/
}

.highcharts-drilldown-data-label text{
  text-decoration:none !important;
}

div[data-popover="helpsubsets"] {
  left: 68% !important;
  top:0%!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ChartsOnline/ChartsStatus.vue